window.slate = window.slate || {};
window.theme = window.theme || {};

/*= =============== Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */
window.cartenhance = [];
let flage;
slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus($element) {
    const focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash() {
    const hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks() {
    $('a[href*=#]').on('click', (evt) => {
      this.pageLinkFocus($(evt.currentTarget.hash));
    });
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus(options) {
    const eventName = options.namespace
      ? `focusin.${options.namespace}`
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, (evt) => {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus(options) {
    const eventName = options.namespace
      ? `focusin.${options.namespace}`
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  },
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled() {
    let cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  },
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance(array, key, value) {
    for (let i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance(array, key, value) {
    let i = array.length;
    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact(array) {
    let index = -1;
    const length = array == null ? 0 : array.length;
    let resIndex = 0;
    const result = [];

    while (++index < length) {
      const value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value;
  },
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {

  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable(options) {
    const tableWrapperClass = typeof options.tableWrapperClass === 'undefined' ? '' : options.tableWrapperClass;

    options.$tables.wrap(`<div class="${tableWrapperClass}"></div>`);
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe(options) {
    const iframeWrapperClass = typeof options.iframeWrapperClass === 'undefined' ? '' : options.iframeWrapperClass;

    options.$iframes.each(function () {
      // Add wrapper to make video responsive
      $(this).wrap(`<div class="${iframeWrapperClass}"></div>`);

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  },
};
slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance(container, constructor) {
    const $container = $(container);
    const id = $container.attr('data-section-id');
    const type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    const instance = $.extend(new constructor(container), {
      id,
      type,
      container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad(evt) {
    const container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload(evt) {
    const instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect(evt) {
    const instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect(evt) {
    const instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder(evt) {
    const instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect(evt) {
    const instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect(evt) {
    const instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register(type, constructor) {
    this.constructors[type] = constructor;

    $(`[data-section-type=${type}]`).each((index, container) => {
      this._createInstance(container, constructor);
    });
  },
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  const moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
      const centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney,
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function () {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (let i = 0; i < images.length; i++) {
      const image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    if (!src) { return null; }
    const match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    const match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      const prefix = src.split(match[0]);
      const suffix = match[0];

      return this.removeProtocol(`${prefix[0]}_${size}${suffix}`);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload,
    loadImage,
    imageSize,
    getSizedImageUrl,
    removeProtocol,
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions() {
      let currentOptions = $.map($(this.singleOptionSelector, this.$container), (element) => {
        const $element = $(element);
        const type = $element.attr('type');
        const currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions() {
      const selectedValues = this._getCurrentOptions();
      const variants = this.product.variants;
      let found = false;

      variants.forEach((variant) => {
        let satisfied = true;

        selectedValues.forEach((option) => {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange() {
      const variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant,
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateButtonCart(variant);
      this._updateStickyATC(variant);
      this.currentVariant = variant;
      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
      this._updateEnhanceOptions(variant);
      this._updateFullDetailLink(variant);
      this._updateQuickViewSwym(variant);
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages(variant) {
      const variantImage = variant.featured_image || {};
      const currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant,
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant,
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState(variant) {
      if (!history.replaceState || !variant || !document.body.classList.contains('template-product')) {
        return;
      }

      const newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?variant=${variant.id}`;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    },

    /**
     * Update add to cart of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateButtonCart(variant) {
      // $('button.btn.btn--primary.btn--add-to-cart').attr('data-cart-add', variant.id);
      if (variant.available) {
        $('button.btn.btn--primary.btn--add-to-cart').prop('disabled', false);
        $('.quantity__container').removeClass('hide');
        $('.quantity--grid-container').addClass('four-fifths medium--six-tenths');
        $('.quantity--grid-container2').removeClass('medium--one-third');
        $('.quantity--grid-container2').removeClass('hide');
        $('.notify-me-btn').addClass('hide');
        $('.wishlist-btn').addClass('medium--three-tenths');
        $('.wishlist-btn').removeClass('medium--one-third');
      } else {
        $('button.btn.btn--primary.btn--add-to-cart').prop('disabled', true);
        $('.quantity__container').addClass('hide');
        $('.quantity--grid-container').removeClass('four-fifths medium--six-tenths');
        $('.quantity--grid-container').addClass('medium--one-third');
        $('.quantity--grid-container2').addClass('hide');
        $('.notify-me-btn').removeClass('hide');
        $('.wishlist-btn').removeClass('medium--three-tenths');
        $('.wishlist-btn').addClass('medium--one-third');
      }

      $('#BIS_trigger').attr('data-variant-id', variant.id);
    },
    _updateStickyATC(variant) {
      if (variant.available) {
        $('.sticky-atc-banner-wrapper').removeClass('hide_sticky');
        $('.sticky-atc-banner-wrapper').addClass('show_sticky');
      } else {
        $('.sticky-atc-banner-wrapper').addClass('hide_sticky');
        $('.sticky-atc-banner-wrapper').removeClass('show_sticky');

      }
    },

    _updateEnhanceOptions(variant) {
      if (!variant.available) {
        $(".main_enhance").addClass("checkbox-disabled"); 
        $(".product__out-stock-notice").removeClass("hide"); 
      } else {
        $(".main_enhance").removeClass("checkbox-disabled"); 
        $(".product__out-stock-notice").addClass("hide"); 
      }
    },

    _updateFullDetailLink(variant) {
      const productUrl = $('[data-product-full-url-link]').data('url');
      let newUrl;

      if (variant) {
        newUrl = `${productUrl}?variant=${variant.id}`;
      } else {
        newUrl = productUrl;
      }
      $('[data-product-full-url-link]').attr('href', newUrl);
    },

    _updateQuickViewSwym(variant) {
      if (variant) {
        const wishlistButton = $('.modal-quickview .swym-add-to-wishlist-view-product');
        wishlistButton.attr('data-variant-id', variant.id);
        document.dispatchEvent(new CustomEvent("swym:quickview-loaded"));
      }
      // document.dispatchEvent (new CustomEvent('swym:variant-change', { detail: variant }));
    }
  });

  return Variants;
})();


/*= =============== Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function () {

  const selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    productSku: '[data-sku-element]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    saleTag: '[data-sale-indicator]',
    outStock: '[data-stock-out]',
    inStock: '[data-stock-in]',
    availability: '[data-availability]',
    stockDate: '[data-release-date]',
    promoText: '[data-promo-text]',
    msrp: '[data-msrp]',
    msrpContainer: '[data-msrp-container]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price-el]',
    productLoginPrice: '[data-product-login-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    const sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    const options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject,
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on(`variantChange${this.namespace}`, this.updateAddToCartState.bind(this));
    this.$container.on(`variantChange${this.namespace}`, this.updateSKU.bind(this));
    this.$container.on(`variantPriceChange${this.namespace}`, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      // slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on(`variantImageChange${this.namespace}`, this.updateProductImage.bind(this));
    }

    // If the variant is OOS and the product is tagged with bis-hidden, the wishlist button gets hidden
    if (window.ehouse.product) {
      if (this.variants.currentVariant.available == false && window.ehouse.product.tags.includes('bis-hidden')) {
        $('[data-pdp-wishlist]').css('opacity', 0);
        $('[data-pdp-wishlist]').css('pointer-events', 'none');
        $('[data-pdp-wishlist]').css('height', '0');
      } else {
        $('[data-pdp-wishlist]').css('opacity', 1);
        $('[data-pdp-wishlist]').css('pointer-events', 'auto');
        $('[data-pdp-wishlist]').css('height', 'auto');
      }
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState(evt) {
      const variant = evt.variant;
      
      // If the variant is OOS and the product is tagged with bis-hidden, the wishlist button gets hidden
      const swymBar = document.querySelector('.swym-button-bar')
      if (swymBar) {
        if (variant.available == false && window.ehouse.product.tags.includes('bis-hidden')) {
          swymBar.style.display = 'none';
        } else {
          swymBar.style.display = 'block';
        }
      }

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html('out of stock');
        $(selectors.priceWrapper, this.$container).addClass('hide');
        $(selectors.outStock, this.$container).removeClass('hide');
        $(selectors.inStock, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
        $(selectors.outStock, this.$container).addClass('hide');
        $(selectors.inStock, this.$container).removeClass('hide');

      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html('out of stock');
        $(selectors.inStock, this.$container).addClass('hide');
        $(selectors.outStock, this.$container).removeClass('hide');
        if (typeof variantsRelease !== 'undefined' && variantsRelease[variant.id] != null && variantsRelease != '') {
          $(selectors.stockDate, this.$container).html(variantsRelease[variant.id]);
          // console.log('wrightplacebw');
          $(selectors.addToCartText, this.$container).html(variantsRelease[variant.id]);
        } else {
          $(selectors.stockDate, this.$container).html('out of stock');
        }

      }
      document.body.className = document.body.className.replace('cart-error', '');
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices(evt) {
      const variant = evt.variant;
      const $productPrice = $(selectors.productPrice, this.$container);
      const $productLoginPrice = $(selectors.productLoginPrice, this.$container);
      const $comparePrice = $(selectors.comparePrice, this.$container);
      const $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);
      const $saleTag = $(selectors.saleTag, this.$container);

      if (typeof variantsLoginPrice !== 'undefined' && variantsLoginPrice[variant.id] != '') {
        $(selectors.productLoginPrice, this.$container).html(variantsLoginPrice[variant.id]);
      } else {
        $(selectors.productPrice, this.$container)
          .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));
      }

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
        $productPrice.addClass('sale');
        $saleTag.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
        $productPrice.removeClass('sale');
        $saleTag.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage(evt) {
      const variant = evt.variant;
      const sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    updateSKU(evt) {
      const variant = evt.variant;
      const $sku = $(selectors.productSku, this.$container);
      // Update the sku
      $($sku).html(variant.sku);

      if (typeof variantsPromoText !== 'undefined' && variantsPromoText[variant.id] != '') {
        $(selectors.promoText, this.$container).removeClass('hide');
        $(selectors.promoText, this.$container).html(variantsPromoText[variant.id]);
      } else {
        $(selectors.promoText, this.$container).addClass('hide');
      }

      if (typeof variantsMSRP !== 'undefined' && variantsMSRP[variant.id] != '') {
        $(selectors.msrpContainer, this.$container).removeClass('hide');
        $(selectors.msrp, this.$container).html(variantsMSRP[variant.id]);
      } else {
        $(selectors.msrpContainer, this.$container).addClass('hide');
      }
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload() {
      this.$container.off(this.namespace);
    },
  });

  return Product;
})();

const LazyLoad = {

  /**
   * Set the background image as a media query on an element
   *
   * @param: {Node} tile: the element to add the CSS background image srcset to
   */
  setTileMediaQueries: (tile) => {
    const tileIdentifier = tile.getAttribute('data-io-id');
    const tileImagesRaw = tile.getAttribute('io-bg-srcset');
    const tileImages = tileImagesRaw.split(',');
    const stylesElement = document.createElement('style');
    tileImages.forEach((tileImage) => {
      const imageParts = tileImage.trim().split(' ');
      stylesElement.innerHTML += `@media screen and (min-width: ${imageParts[1]}) {
        [data-io-id="${tileIdentifier}"] {
          background-image: url('${imageParts[0]}');
        }
      }`;
    });
    document.body.appendChild(stylesElement);
  },

  /**
   * Default callback for the lazyloader. Will load in image sources and then unobserve the element
   *
   * @param: {Node} tile: the element just loaded into the viewport
   * @param: {Object} observer: the observer that is watching/notifiying the tile element
   * @param: {boolean} isIntersecting: whether the tile is in the viewport or if it just left the viewport
   */
  setTileBackground: (tile, observer, isIntersecting) => {
    // only set img sources if the tile is in the viewport
    if (!isIntersecting) {
      return;
    }
    // check if the element has a CSS background to be set
    if (tile.hasAttribute('io-bg-src')) {
      const backgroundURL = tile.getAttribute('io-bg-src');
      tile.style.backgroundImage = `url('${backgroundURL}')`;
    }
    // check if there is a sourceset for setting backgrounds via CSS
    if (tile.hasAttribute('io-bg-srcset')) {
      LazyLoad.setTileMediaQueries(tile);
    }
    // check if there is a src to set on an image tag
    if (tile.hasAttribute('io-img-src')) {
      const src = tile.getAttribute('io-img-src');
      tile.setAttribute('src', src);
      // also check if the img tag has a srcset attribute to set
      if (tile.hasAttribute('io-img-srcset')) {
        const srcset = tile.getAttribute('io-img-srcset');
        tile.setAttribute('srcset', srcset);
      }
    }
    // unobserve the tile
    if (observer) {
      observer.unobserve(tile);
    }
    // need to notify of the image loading in
    const imageEvent = new CustomEvent('ioSourceSet', {
      detail: { target: tile },
    });
    document.dispatchEvent(imageEvent);
  },

  /**
   * Binds an observer to given elements if IOs exist in the browser
   *
   * @param: {NodeList} toObserve: list of elements that will be observed by the single observer
   * @param: {Function} successCallback: the callback for when an element is lazyloaded / enters/exits the viewport
   * @param: {Function} errorCallback: callback called on a per element basis if the browser doesn't support intersection observers
   * @param: {String} margins: string with the margins for when an element counts as being in the viewport
   */
  createObservers: ({ toObserve, successCallback, errorCallback, margins }) => {
    // check if IOs are available or not
    if ('IntersectionObserver' in window) {
      // define everything we need to pass to the callback
      const rootMargin = { rootMargin: margins };
      const callback = (entries, observer) => {
        entries.forEach((entry) => {
          successCallback(entry.target, observer, entry.isIntersecting);
        });
      };
      // our actual observer
      const observer = new IntersectionObserver(callback, rootMargin);
      // have to bind to each individual tile
      toObserve.forEach((tile) => {
        observer.observe(tile);
      });
    } else {
      // If there is an error callback defined, use it. Otherwise, fallback to default success callback
      const callback = errorCallback !== false ? errorCallback : successCallback;
      toObserve.forEach((tile) => {
        callback(tile, false, true);
      });
    }
  },

  /**
   * Setup observers for a group of elements on the page
   *
   * @param: {String} queryString: a query query for grabbing all elements to observe
   * @param: {Function} callback: the callback function for when the elements enter/exit the view
   * @param: {Function} errorCallback: the callback function for if Intersection Observers are not available in the current browser.
   * @param: {String} margins: string representing the bounds for when the tiles load
   */
  setupObservers: ({ queryString = '[io-img-src], [io-img-srcset], [io-bg-src], [io-bg-srcset]', callback = LazyLoad.setTileBackground, errorCallback = false, margins = '0% 0% 0% 0%' } = {}) => {
    const toObserve = document.querySelectorAll(queryString);
    LazyLoad.createObservers({
      toObserve,
      successCallback: callback,
      errorCallback,
      margins,
    });
  },
};

/*= =============== Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function () {
  const $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew',
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function () {
    const formId = $(this).data('form-id');
    const countrySelector = `AddressCountry_${formId}`;
    const provinceSelector = `AddressProvince_${formId}`;
    const containerSelector = `AddressProvinceContainer_${formId}`;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector,
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function () {
    if (!$('.edit-address-form').hasClass('hide')) {
      $('.edit-address-form').addClass('hide');
    }
    if (!$('.js-noEdit').hasClass('hide')) {
      $('.js-noEdit').addClass('hide');
    } else {
      $('.js-noEdit').removeClass('hide');
    }

    $newAddressForm.toggleClass('hide');

    if ($(this).hasClass('js-isCancel')) {
      $('html, body').animate({
        scrollTop: 0,
      }, 1000);
    }
  });

  $('.address-edit-toggle').on('click', function () {
    if (!$newAddressForm.hasClass('hide')) {
      $newAddressForm.addClass('hide');
    }
    if (!$('.js-noEdit').hasClass('hide')) {
      $('.js-noEdit').addClass('hide');
    } else {
      $('.js-noEdit').removeClass('hide');
    }

    const formId = $(this).data('form-id');
    $(`#EditAddress_${formId}`).toggleClass('hide');

    if ($(this).hasClass('js-isCancel')) {
      $('html, body').animate({
        scrollTop: 0,
      }, 1000);
    }
  });

  $('.address-delete').on('click', function () {
    const $el = $(this);
    const formId = $el.data('form-id');
    const confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink(`/account/addresses/${formId}`, { parameters: { _method: 'delete' } });
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function () {
  const config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink',
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    const hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    const $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


site = {
  browserWidth: 0,
  setBrowserWidth() {
    site.browserWidth = window.innerWidth || document.documentElement.clientWidth;
  },
  initNavigation() {
    // NAVIGATION //

    $nav = $('.js-nav');
    $navToggle = $('.js-navToggleBtn'); // this opens the nav < xlarge
    $subNavButton = $('.js-subnavToggleBtn'); // this is for touching
    $subNavToggle = $subNavButton.parent('li'); // this is for hovering
    $subNavBgToggle = $subNavButton.parent('.js-hasDropdown'); // this is for hovering
    $subNavBgToggle2 = $('.site-nav'); // this is for hovering
    $buttonLink = $('.js-link'); // When a button is clickable as link

    $submenuToggle = $('.js-submenuBtn');
    $submenu = $('.dropdown-wrap');
    $submenuBackBtn = $('.js-submenuBackBtn');

    $thirdmenuToggle = $('.js-thirdmenuBtn');
    $thirdmenu = $('.js-thirdmenu');
    $submenuBackBtn = $('.js-submenuBackBtn');

    $stickySearchToggle = $('[data-js-sticky-search-toggle]');
    $stickySearchClose = $('[data-js-sticky-search-close]');

    $submenuBackBtn.on('click', closeSubMenu);
    $thirdmenuToggle.on('click', toggleThirdMenu);

    $navToggle.on('click', toggleNav);
    $subNavButton.on('click', openSubNav);
    $submenuToggle.on('click', openSubMenu);
    $subNavToggle.hoverIntent({ over: dropDown, timeout: 200 });
    $subNavBgToggle2.hoverIntent({ over: dropBg, timeout: 200 });
    $buttonLink.on('click', buttonLink);

    $stickySearchToggle.on('click', handleStickySearchClick);
    $stickySearchClose.on('click', hideStickySearchForm);

    $(document).on('click', '.header__search-form-clear', function () {
      $('[name="q"]').val('');
      $('[name="q"]').focus();
      $(this).css('visibility', 'hidden');
    })

    function hideStickySearchForm() {
      $('body').removeClass('show-sticky-search-form');
    }

    function handleStickySearchClick() {
      if ($('body').hasClass('show-sticky-search-form')) {
        $('body').removeClass('show-sticky-search-form');
      } else {
        $('body').addClass('show-sticky-search-form');
      }
    }

    function toggleThirdMenu(event) {
      event.preventDefault();

      $(this).toggleClass('is-active').next($thirdmenu)
        .toggleClass('is-active');
    }

    function openSubMenu(event) {
      if (site.browserWidth < 1025) {
        event.preventDefault();

        $(this).next($submenu).addClass('is-active');
      }
    }

    function closeSubMenu(event) {
      if (site.browserWidth < 1025) {
        event.preventDefault();

        $(this).parent($submenu).removeClass('is-open');
        $('.dropdown-wrap').removeClass('is-open');
        // $('.dropdown').hide();
        $('.js-subnavToggleBtn').removeClass('is-open');
      }
    }

    function dropDown() {
      if (site.browserWidth >= 1025) {
        $(this)
          .children('button')
          .first()
          .toggleClass('is-open')
          .next('.dropdown-wrap')
          .toggleClass('is-open');
      }
    }

    function dropBg(event) {
      if (site.browserWidth >= 1025) {
        if (event.target.classList.contains('site-nav__link--btn') && event.target.classList.contains('no-child')) {
          $(this).removeClass('is-open');
        } else {
          $(this).toggleClass('is-open');
        }
      }
    }

    function openSubNav(event) {
      event.preventDefault();

      function Drop() {
        $(this)
          .children('button')
          .first()
          .toggleClass('is-open')
          .next('.dropdown-wrap')
          .toggleClass('is-open');
      }

      if (site.browserWidth < 1025 && event.type == 'click') {
        $(this)
          .toggleClass('is-open')
          .next('.dropdown-wrap')
          // .slideToggle()
          .toggleClass('is-open');
      } else if (site.browserWidth >= 1025 && (event.type == 'mouseenter' || event.type == 'mouseleave')) {
        // You are large, and you hovered
        // Not using this now, instead using hover intent and dropDown

      } else {
        // Die for all other events
        return false;
      }
    }

    function toggleNav(event) {
      event.preventDefault();

      $nav.toggleClass('active');
      $('body').toggleClass('nav-active');
      $navToggle.toggleClass('is-active');
    }

    function buttonLink(event) {
      event.preventDefault();

      if ($(this).hasClass('enable-on-mobile')) {
        window.location = $(this).data('href');
      } else {
        if (site.browserWidth >= 1025) {
          window.location = $(this).data('href');
        }
      }
    }

  },
  initScrollLink() {
    $('.js-scrollLink').on('click', function (e) {
      e.preventDefault();
      const $link = $(this).attr('href');

      $('html, body').animate({
        scrollTop: $($link).offset().top,
      }, 500);

    });

    $('.js-scrollDiv').on('click', function (e) {
      e.preventDefault();
      const $link = $(this).data('href');
      const $linkContent = $($link).find('.js-readMoreContent');

      $('html, body').animate({
        scrollTop: $($link).offset().top - 100,
      }, 500);

      if (!($linkContent).hasClass('open')) {
        $($link).find('.js-readMoreBtn').click();
      }
    });

    if (window.location.hash) {
      const url = window.location.href;
      const hash = url.substring(url.indexOf('#'));

      $('html, body').animate({
        scrollTop: $(hash).offset().top - 100,
      }, 500);

      $(hash).next('.js-toggleContent').slideToggle();
      $(hash).toggleClass('is-open');
    }
  },

  initCssVariables() {
    const $announcementBanner = $('.announcement-banners');
    let announcementBannerShowingHeight = 0;
    const headerHeight = Math.floor($('.site-header').outerHeight());

    if ($announcementBanner) {
      announcementBannerHeight = Math.floor($('.announcement-banners').outerHeight());
      announcementBannerScolledY = Math.abs($announcementBanner[0].getBoundingClientRect().y);
      if (announcementBannerHeight >= announcementBannerScolledY) {
        announcementBannerShowingHeight = announcementBannerHeight - announcementBannerScolledY;
      }
    }
    document.documentElement.style.setProperty('--announcement-header-height', `${announcementBannerShowingHeight}px`);
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
  },

  initToggleContent() {
    $('.js-toggleBtn').on('click', function (e) {
      $(this).next('.js-toggleContent').slideToggle();
      $(this).toggleClass('is-open');
    });
  },

  initShowMore() {
    $('.js-showMore').on('click', function (e) {
      if ($(this).hasClass('is-open')) {
        $(this).text('+ show more images').removeClass('is-open');
        $('.product-thumbs .mz-thumb:nth-child(1n + 11)').css('display', 'none');
        $('.product-gallery__slide.desktop-only:nth-child(1n + 11)').css('display', 'none');
        window.scrollTo({top: 0, behavior: 'smooth'});
      } else {
        $(this).text('- show less images').addClass('is-open');
        $('.product-thumbs .mz-thumb').css('display', 'block');
        $('.product-gallery__slide.desktop-only:nth-child(1n + 11)').css('display', 'block');
      }
    });

    // PDP Video play
    $('[data-btn-play-video]').on('click', function (e) {
      const wrap = e.target.closest('[data-slide-id]');
      let video = wrap.querySelector('video')
      if (!video) {
        const slideId = e.currentTarget.dataset.slideId;
        video = document.querySelector(`.product-gallery__slide--mobile[data-slide-id=${slideId}] video`);
      }

      if (video) {
        $(this).toggleClass('playing');
        if ($(this).hasClass('playing')) {
          video.play();
        } else {
          video.pause();
        }
      }
    })

    $('.product-thumbs .mz-thumb').first().click()
  },

  initAppendAround() {
    $('.js-appendaroundContent').appendAround();
  },

  initListToSelect() {
    $selectNav = $('.js-selectNav');

    // Create the dropdown base
    $("<select class='page-nav__select js-page-nav-select' />").appendTo($selectNav);
    // Create the dropdown base

    // Populate dropdown with menu items
    $($selectNav).find('a').each(function () {
      let $item = $(this),
        $selected = $item.hasClass('current');
      $('<option />', {
        value: $item.attr('href'),
        text: $item.text(),
        selected: $selected,
      }).appendTo('.js-page-nav-select');

    });

    $selectNav.on('change', () => {
      $selectedNav = $('.js-page-nav-select option:selected');

      if ($selectedNav !== '') {
        window.location.href = $selectedNav.val();
      }
    });
  },

  initScrollIndicate() {
    if ($(window).scrollTop() < 300) {
      $('body').removeClass('scrolled');
    } else {
      $('body').addClass('scrolled');
    }
  },

  initNavStick() {
    const offset = -115;
    if ($('.site-header')[0].getBoundingClientRect().y > offset) {
      $('body').removeClass('sticky-nav-enabled');
    } else {
      $('body').addClass('sticky-nav-enabled');
    }
  },

  initATCStick() {
    if ($('body').hasClass('template-product')) {
      if ($(window).scrollTop() >= $('#AddToCart').offset().top + $('#AddToCart').outerHeight()) {
        $('.sticky-atc-banner-wrapper').addClass('active');
        $('.site-nav__container').addClass('added-atc');
      } else {
        $('.sticky-atc-banner-wrapper').removeClass('active');
        $('.site-nav__container').removeClass('added-atc');
      }
    }
  },

  initBackTop() {
    $('.js-backToTop').click(() => {
      $('html, body').animate({
        scrollTop: 0,
      }, 1000);
    });
  },

  initFormValidate() {
    $('.js-newsletterFormContainer form').validate({
      rules: {
        'contact[email]': {
          required: true,
          email: true,
        },
      },
      messages: {
        'contact[email]': {
          required: 'Please enter your email address.',
          email: 'Please enter a valid email address.',
        },
      },
      errorPlacement(error, element) {
        error.insertBefore('.input-group');
      },
    });

    $('.js-contactForm form#contact_form').validate({
      rules: {
        'contact[name]': {
          required: true,
        },
        'contact[email]': {
          required: true,
          email: true,
        },
        'contact[body]': {
          required: true,
        },
      },
      messages: {
        'contact[name]': {
          required: 'Please enter your name.',
        },
        'contact[email]': {
          required: 'Please enter your email address.',
          email: 'Please enter a valid email address.',
        },
        'contact[body]': {
          required: 'Please provide a brief message.',
        },
      },
    });
    $('#CustomerLoginForm form#customer_login, form#create_customer, form#activate_customer_password').validate({
      rules: {
        'customer[email]': {
          required: true,
          email: true,
        },
        'customer[password]': {
          required: true,
        },
      },
      messages: {
        'customer[email]': {
          required: 'Please enter your email address.',
          email: 'Please enter a valid email address.',
        },
        'customer[password]': {
          required: 'Please enter password.',
        },
      },
    });
    $('#RecoverPasswordForm form').validate({
      rules: {
        email: {
          required: true,
          email: true,
        },
      },
      messages: {
        email: {
          required: 'Please enter your email address.',
          email: 'Please enter a valid email address.',
        },
      },
    });
  },

  initGallery() {
    $('.js-slider').slick({
      lazyLoad: 'progressive',
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      adaptiveHeight: true,
      customPaging(slick, index) {
        return `<button style="background-image:url(${$(slick.$slides[index]).data('thumb')});"></button>`;
      },
      responsive: [
        {
          breakpoint: 480,
          settings: {
            arrows: false,
          },
        },
        {
          breakpoint: 768,
          settings: {
            arrows: true,
          },
        }],
    });
    $('.js-slider').show();
  },

  initGallerySwatch() {
    $('.js-slider-swatch').slick({
      lazyLoad: 'progressive',
      slidesToShow: 5,
      slidesToScroll: 1,
      dots: true,

    });
    $('.js-slider-swatch').show();
  },


  initReadMore() {
    $('.js-readMoreBtn').on('click', function (e) {
      e.preventDefault();

      let openText = '';
      if ($(this).hasClass('js-readMoreBtn--videos')) {
        openText = '+ see more';
      } else if ($(this).hasClass('js-readMoreBTN--orderSummary')) {
        openText = '+ view order summary';
      } else {
        openText = '+ read more';
      }
      if ($(this).hasClass('is-open')) {
        $(this).removeClass('is-open').html(`<span>${openText}</span>`)
          .parent()
          .find('.js-readMoreContent')
          .removeClass('open');

        $(this).removeClass('is-open').html(`<span>${openText}</span>`)
          .parent()
          .find('.read-more__content2')
          .removeClass('open');

      } else {
        $(this).addClass('is-open').html('<span>- show less</span>')
          .parent()
          .find('.js-readMoreContent')
          .addClass('open');

        $(this).addClass('is-open').html('<span>- show less</span>')
          .parent()
          .find('.read-more__content2')
          .addClass('open');
      }


    });
  },

  initQuantityIncrement() {
    $('body').on('click', '.js-increment', function (e) {
      e.preventDefault();
      const $button = $(e.currentTarget);
      const $input = $button.parent().find('input');
      const maxValue = parseFloat($input.attr('max'));

      const hasMax = !isNaN(maxValue);
      const oldValue = parseFloat($input.val()) || 0;
      let newValue = oldValue;
      let blockedByLimit = false;

      if ($button.text() == '+') {
        newValue = oldValue + 1;

        // Clamp to the limit, but never silently lower a quantity that is already over it
        if (hasMax && newValue > maxValue) {
          newValue = Math.max(oldValue, maxValue);
          blockedByLimit = true;
        }
      } else if (oldValue > 0) {
        // Don't allow decrementing below zero
        newValue = oldValue - 1;
      }

      const $cartItem = $button.closest('.cart-products__products-item');

      if ($cartItem.length > 0) {
        // Update all qty of cart line item
        $cartItem.find('input.stepper-input').val(newValue);
      } else {
        $button.parent().find('input').val(newValue);
      }

      site.checkHasOverPurchasedProducts();

      if (newValue !== oldValue) {
        $input.trigger('change');
      } else if (blockedByLimit && $cartItem.length > 0) {
        // No request goes out when the click is clamped, so say why the quantity did not move
        showPurchaseLimitNotice($cartItem, maxValue);
      }
    });

    // Enter inside a cart quantity field would otherwise submit the cart form straight to checkout,
    // skipping the limit validation entirely. Commit the quantity instead.
    $('body').on('keydown', '.cart-products__products-item .stepperInput__input', function (e) {
      if (e.key === 'Enter' || e.keyCode === 13) {
        e.preventDefault();
        $(this).trigger('change');
      }
    });

    function updateCartContents(itemRow, qtyVal, itemKey) {
      // Get the elements to update after the item quantity gets updated in the cart
      const $currentTotal = $(`[data-item-total="${itemKey}"]`);
      const $currentCartSummary = $('.cart-summary__table');
      const $currentCartCount = $('.header__cart-btn--count');
      const $currentOrderTotal = $('.cart-header__subtotal');
      const $currentHeaderItemCount = $('[data-header-item-count]');

      $.ajax({
        type: 'get',
        url: '/cart',
        success(data) {
          const $updatedTotal = $(data).find(`[data-item-total="${itemKey}"]`).html();
          const $updatedCartSummary = $(data).find('.cart-summary__table').html();
          const $updatedCartCount = $(data).find('.header__cart-btn--count').html();
          const $updatedOrderTotal = $(data).find('.cart-header__subtotal').html();

          // Update dom with the correct updated values
          $currentTotal.html($updatedTotal);
          $currentCartSummary.html($updatedCartSummary);
          $currentCartCount.html($updatedCartCount);
          $currentOrderTotal.html($updatedOrderTotal);
          $currentHeaderItemCount.html($updatedCartCount);

          // Scope to this row: selecting by variant id also hit other lines sharing the variant
          itemRow.find('input.stepper-input').data('item-qty', qtyVal);

          if (parseFloat($updatedCartCount) <= 1) {
            $('[data-header-item-unit]').html('item');
          } else {
            $('[data-header-item-unit]').html('items');
          }

          // Re-enable the item row after the cart updated
          itemRow.removeClass('disabled');
          site.checkHasOverPurchasedProducts();
        },
        error() {
          itemRow.removeClass('disabled');
          site.checkHasOverPurchasedProducts();
        },
      });
    }

    // Shopify answers 429 (rate limit) / 430 (bot protection) when the cart is hit too fast.
    // Retry a couple of times before surfacing an error so a burst of clicks doesn't look like a silent failure.
    function changeLineQuantity(options) {
      const attempt = options.attempt || 0;

      $.ajax({
        type: 'post',
        dataType: 'json',
        url: '/cart/change.js',
        data: {
          line: options.line,
          quantity: options.quantity
        },
        success: options.success,
        error(xhr) {
          const isRateLimited = xhr.status === 429 || xhr.status === 430;

          if (isRateLimited && attempt < 2) {
            const retryAfter = parseInt(xhr.getResponseHeader('Retry-After'), 10);
            const waitMs = !isNaN(retryAfter) && retryAfter > 0
              ? retryAfter * 1000
              : Math.min(1000 * Math.pow(2, attempt), 4000);

            window.setTimeout(() => {
              changeLineQuantity($.extend({}, options, { attempt: attempt + 1 }));
            }, waitMs);
            return;
          }

          options.error(xhr, isRateLimited);
        },
      });
    }

    // One in-flight /cart/change.js per line; latest typed/clicked qty wins.
    const cartLineUpdates = {};

    function scheduleCartLineUpdate($input) {
      const $itemRow = $input.closest('.cart-products__products-item');
      const itemKey = $input.data('item-key');

      if (!itemKey || !$itemRow.length) {
        return;
      }

      const qtyVal = parseInt($input.val(), 10);
      const oldVal = parseInt($input.data('item-qty'), 10);
      const state = cartLineUpdates[itemKey] || (cartLineUpdates[itemKey] = {});

      if (isNaN(qtyVal)) {
        $itemRow.find('input.stepper-input').val(oldVal);
        site.checkHasOverPurchasedProducts();
        return;
      }

      state.$input = $input;
      state.$itemRow = $itemRow;
      state.itemLine = $input.data('item-line');
      state.qtyVal = qtyVal;
      state.oldVal = oldVal;

      window.clearTimeout(state.timer);
      state.timer = window.setTimeout(function () {
        flushCartLineUpdate(itemKey);
      }, 300);
    }

    function flushCartLineUpdate(itemKey) {
      const state = cartLineUpdates[itemKey];

      if (!state) {
        return;
      }

      if (state.inflight) {
        state.queued = true;
        return;
      }

      if (isNaN(state.qtyVal) || state.qtyVal === state.oldVal) {
        site.checkHasOverPurchasedProducts();
        return;
      }

      const $input = state.$input;
      const $itemRow = state.$itemRow;
      const qtyVal = state.qtyVal;
      const oldVal = state.oldVal;

      state.inflight = true;
      $itemRow.addClass('disabled');
      clearCartLineError($itemRow);
      site.checkHasOverPurchasedProducts();

      changeLineQuantity({
        line: state.itemLine,
        quantity: qtyVal,
        success(cart) {
          state.oldVal = qtyVal;

          if (qtyVal === 0) {
            window.location.reload(true);
            return;
          }

          if (cart && typeof cart.total_price !== 'undefined' && typeof calculateCartProgress === 'function') {
            calculateCartProgress(cart.total_price, window.setThreshold * 100);
          }

          updateCartContents($itemRow, qtyVal, itemKey);
          finishCartLineUpdate(itemKey);
        },
        error(xhr, isRateLimited) {
          const response = xhr.responseJSON || {};
          let message = response.description || response.message || 'Unable to update item quantity due to availability.';

          if (isRateLimited) {
            message = 'Too many cart updates in a short time. Refreshing the page…';
          }

          $input.val(oldVal);
          $itemRow.find('input.stepper-input').val(oldVal);
          $itemRow.removeClass('disabled');
          showCartLineError($itemRow, message);
          site.checkHasOverPurchasedProducts();
          finishCartLineUpdate(itemKey);

          if (isRateLimited) {
            window.setTimeout(function () {
              window.location.reload();
            }, 3000);
          }
        },
      });
    }

    function finishCartLineUpdate(itemKey) {
      const state = cartLineUpdates[itemKey];

      if (!state) {
        return;
      }

      state.inflight = false;

      if (state.queued) {
        state.queued = false;
        flushCartLineUpdate(itemKey);
      }
    }

    function showCartLineError($itemRow, message) {
      const $error = $itemRow.find('[data-cart-line-error]').first();
      if ($error.length) {
        $error.text(message).prop('hidden', false);
        return;
      }

      // Fallback if liquid slot is missing
      $itemRow.find('.cart-products__product-content').first().prepend(
        $('<p class="cart-line-error" data-cart-line-error role="alert"></p>').text(message)
      );
    }

    function clearCartLineError($itemRow) {
      const $error = $itemRow.find('[data-cart-line-error]');
      $error.text('').prop('hidden', true);
    }

    function showPurchaseLimitNotice($itemRow, maxValue) {
      // Reuse the wording the section already renders so both messages stay in sync
      const limitMessage = $.trim($itemRow.find('[data-purchase-limit-error]').text())
        || `You can only purchase this product maximum ${maxValue}.`;

      showCartLineError($itemRow, limitMessage);
    }

    $('body').on('change paste keyup', '.stepperInput__input', function () {
      const newVal = $(this).parent().find('input').val();

      if ($(this).closest('.cart-products__products-item').length > 0) {
        // Update all qty of cart line item
        const $cartItem = $(this).closest('.cart-products__products-item');
        $cartItem.find('input.stepper-input').val(newVal);
      } else {
        $(this).closest('.js-productBuyContainer').find('.js-quantityValue')
          .html(newVal);
      }

      site.checkHasOverPurchasedProducts();
    });

    // Commit like minicart QtySelector: +/- and `change` (Enter / leave after edit), not every keystroke.
    // Debounced so a burst of +/- clicks is one Shopify request instead of several 429s.
    $('body').on('change', '[data-qty-adjuster]', function () {
      scheduleCartLineUpdate($(this));
    });

    // Last gate: a disabled button is only a hint, so block the submit itself. This also covers
    // implicit submits and a button that was re-enabled after the cart changed.
    $('body').on('submit', '[data-js-cart-form]', function (e) {
      if (!site.checkHasOverPurchasedProducts()) {
        return;
      }

      e.preventDefault();

      const $firstOverLimit = $('[data-purchase-limit-error]').not('[hidden]').first();

      if ($firstOverLimit.length) {
        $('html, body').animate({ scrollTop: $firstOverLimit.offset().top - 120 }, 200);
      }
    });

    // Sync the limit messages / checkout button with whatever the cart rendered on load
    site.checkHasOverPurchasedProducts();
  },

  checkHasOverPurchasedProducts() {
    let hasOverPurchasedProducts = false;

    $('.cart-products__products-item').each(function () {
      const $row = $(this);
      const $input = $row.find('input.stepper-input').first();

      if ($input.length === 0) {
        return;
      }

      // parseInt both sides: comparing raw strings made "10" > "5" evaluate false
      const maxValue = parseInt($input.attr('max'), 10);
      const value = parseInt($input.val(), 10);
      const isOverLimit = !isNaN(maxValue) && !isNaN(value) && value > maxValue;

      if (isOverLimit) {
        hasOverPurchasedProducts = true;
      }

      $row.find('[data-purchase-limit-error]').prop('hidden', !isOverLimit);
    });

    $('[data-checkout-btn]').prop('disabled', hasOverPurchasedProducts);

    return hasOverPurchasedProducts;
  },

  initToolTip() {
    var isTouch = ('ontouchstart' in window) || navigator.maxTouchPoints > 0;

    // Touch: keep original click-to-toggle behavior.
    // Desktop: hover + click + keyboard focus can open; do not dismiss on origin click.
    // Closing happens on mouseleave/blur only when the pointer is no longer on the icon/tooltip.
    if (isTouch) {
      $('.tooltip').tooltipster({
        interactive: true,
        maxWidth: 200,
        trigger: 'click',
        side: ['top', 'right', 'bottom', 'left'],
        theme: ['tooltipster-shadow', 'tooltipster-shadow-customized'],
      });
    } else {
      $('.tooltip').tooltipster({
        interactive: true,
        interactiveTolerance: 400,
        delay: [0, 300],
        maxWidth: 200,
        trigger: 'custom',
        triggerOpen: {
          mouseenter: true,
          click: true,
          focus: true,
        },
        triggerClose: {
          // Intentionally omit click/originClick so clicking the icon does not dismiss it.
          mouseleave: true,
          scroll: true,
        },
        side: ['top', 'right', 'bottom', 'left'],
        theme: ['tooltipster-shadow', 'tooltipster-shadow-customized'],
      }).on('blur', function () {
        var $origin = $(this);
        setTimeout(function () {
          // If user clicked an unfocused icon, it gains focus then may blur-race;
          // keep the tooltip open while the pointer is still over the trigger/tooltip.
          if ($origin.is(':focus') || $origin.is(':hover')) return;
          if ($(document.activeElement).closest('.tooltipster-base').length) return;
          if ($('.tooltipster-base:hover').length) return;
          $origin.tooltipster('close');
        }, 200);
      });
    }

    $('.tooltipSpecs').tooltipster({
      interactive: true,
      trigger: 'click',
      maxWidth: 200,
      side: ['right', 'top', 'bottom', 'left'],
      theme: ['tooltipster-shadow', 'tooltipster-shadow-customized', 'tooltipster-specs'],
    });

    // ESC closes open tooltips (e.g. Nib Size: data-tooltip-content="#tooltip_content-nib-size")
    $(document)
      .off('keydown.tooltipEsc')
      .on('keydown.tooltipEsc', function (evt) {
        if (evt.key !== 'Escape' && evt.which !== 27) return;
        if (!$('.tooltipster-base').length) return;

        evt.preventDefault();

        var $focusOrigin = null;
        $('.tooltip.tooltipstered, .tooltipSpecs.tooltipstered').each(function () {
          var $origin = $(this);
          try {
            if ($origin.tooltipster('status').open) {
              $origin.tooltipster('close');
              if (!$focusOrigin) $focusOrigin = $origin;
            }
          } catch (err) {
            // Instance may not be ready; ignore
          }
        });

        if ($focusOrigin && $focusOrigin.length) {
          $focusOrigin.trigger('focus');
        }
      });
  },

  initLazyLoad() {
    const observer = lozad(); // lazy loads elements with default selector as ".lozad"
    observer.observe();
  },

  initProdDesc() {
    if (site.shouldRun('template-product')) {

      const textLength = $('.js-productDesc').text().length;
      const $break = $('.js-productDesc:has(br)');

      if (textLength > 500 && $break.length > 0) {
        $('.js-productDesc').parent().parent()
          .addClass('short');
        $('.js-readMoreBtn--prodDesc').show();
      }
    }
  },

  initInputFocusToggle() {
    $('.js-searchBtnFocusTrigger').on('focus', function () {
      $(this).parent().find('.js-searchBtnFocus')
        .addClass('focused');
    });
    $('.js-searchBtnFocusTrigger').on('focusout', function () {
      $(this).parent().find('.js-searchBtnFocus')
        .removeClass('focused');
    });
  },

  shouldRun(className) {
    return document.body.classList.contains(className);
  },

  run() {
    site.setBrowserWidth();
    site.initNavigation();
    site.initCssVariables();
    site.initAppendAround();
    site.initScrollLink();
    site.initToggleContent();
    site.initListToSelect();
    site.initScrollIndicate();
    site.initBackTop();
    site.initFormValidate();
    site.initGallery();
    site.initGallerySwatch();
    site.initShowMore();
    site.initReadMore();
    site.initQuantityIncrement();
    site.initToolTip();
    site.initNavStick();
    site.initATCStick();
    site.initProdDesc();
    site.initInputFocusToggle();
  },
  resize() {
  },

  helpers: {
    debounce(func, wait, immediate) {
      let timeout;
      return function () {
        let context = this,
          args = arguments;
        const later = function () {
          timeout = null;
          if (!immediate) { func.apply(context, args); }
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) { func.apply(context, args); }
      };
    },
  },
};

function updateCartContents() {
  const $currentCartSummary = $('.cart-summary__table');
  const $currentCartCount = $('.header__cart-btn--count');
  const $currentOrderTotal = $('.cart-header__subtotal');
  const $currentCartItems = $('.cart-products__products');
  const $currentHeaderItemCount = $('[data-header-item-count]');
  const $cartWrap = $('.cart-wrapper')

  $.ajax({
    type: 'get',
    url: '/cart',
    success(data) {
      const $updatedCartSummary = $(data).find('.cart-summary__table').html();
      const $updatedCartCount = $(data).find('.header__cart-btn--count').html();
      const $updatedOrderTotal = $(data).find('.cart-header__subtotal').html();
      const $updatedCartItems = $(data).find('.cart-products__products').html();
      const $updatedCartWrap = $(data).find('.cart-wrapper').html();

      // Update dom with the correct updated values
      $currentCartSummary.html($updatedCartSummary);
      $currentCartCount.html($updatedCartCount);
      $currentCartCount.attr('data-count', $updatedCartCount);
      $currentOrderTotal.html($updatedOrderTotal);
      $currentCartItems.html($updatedCartItems);
      $currentHeaderItemCount.html($updatedCartCount);

      if ($cartWrap && $currentCartItems.length == 0) {
        // If was empty cart
        $cartWrap.html($updatedCartWrap);
        $cartWrap.removeClass('empty-page');
      }

      $('.cart__remove-link').removeClass('disabled');
      $('.cart__qty').removeClass('disabled');

      if (parseFloat($updatedCartCount) <= 1) {
        $('[data-header-item-unit]').html('item');
      } else {
        $('[data-header-item-unit]').html('items');
      }

      // Line items were re-rendered, so re-evaluate the purchase limits against the new markup
      if (typeof site !== 'undefined' && typeof site.checkHasOverPurchasedProducts === 'function') {
        site.checkHasOverPurchasedProducts();
      }

      if (typeof _swat !== 'undefined') {
        _swat.initializeActionButtons('.cart-elements-wrapper');
      }

      if (typeof calculateCartProgress === 'function') {
        const url = ''.concat(theme.routes.cart, '?t=').concat(Date.now());
        fetch(url, {
          credentials: 'same-origin',
          method: 'GET'
        })
        .then(response => response.json())
        .then(cart => {
          console.log('Updating Cart progress bar!')
          const threshold = window.setThreshold * 100;
          const cartTotal = cart.total_price;
          calculateCartProgress(cartTotal, threshold);
          updateShippingProgressBar()
        })
      }
    },
  });
}

$(document).ready(() => {
  const sections = new slate.Sections();
  sections.register('product', theme.Product);

  // CartJS.init(window.ehouse.cart);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', (evt) => {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollableDuplicate Product Image for Zoom Functionality
  const tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  const articleTableSelectors = '.rte--article table';

  slate.rte.wrapTable({
    $tables: $(articleTableSelectors),
    tableWrapperClass: 'rte__table-wrapper--article',
  });

  // Target iframes to make them responsive
  const iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper',
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  const triggerResize = site.helpers.debounce(function () {
    if ($(this).width() != site.browserWidth) {
      site.setBrowserWidth();
    }
  }, 250);

  site.run();

  window.addEventListener('resize', triggerResize);
  window.addEventListener('resize', () => {
    site.initCssVariables();
  })
  $(window).scroll((evt) => {
    site.initScrollIndicate();
    site.initCssVariables();
    site.initNavStick();
    site.initATCStick();
  });


  $('select#Quantity').on('change', function () {
    const productQuantity = this.value;
    const productQtyInt = parseInt(productQuantity);
    $('.btn--add-to-cart').attr('data-cart-quantity', productQtyInt);
    $('body').removeClass('cart-error');
  });

  $('body').on('click', '.cart__remove-link', function (e) {
    const $target = $(e.currentTarget);
    const $lineRow = $target.parents('.cart-products__products-item');
    const cartLine = $target.data('item-line');
    const promise = $.Deferred();
    const settings = {
      'line': cartLine,
      'quantity': 0
    };

    //Disable row to indicate item is being removed
    $lineRow.addClass("disabled");
    $('.cart__remove-link').addClass('disabled');

    function removeCartLine(attempt) {
      const nextAttempt = attempt || 0;

      $.ajax({
        type: 'post',
        dataType: 'json',
        url: '/cart/change.js',
        data: settings,
        success(cart) {
          promise.resolve(cart);

          if (!cart || cart.item_count == 0) {
            window.location.reload(true);
            return;
          }

          calculateCartProgress(cart.total_price, window.setThreshold * 100);
          updateCartContents();
        },
        error(xhr) {
          if ((xhr.status === 429 || xhr.status === 430) && nextAttempt < 2) {
            const retryAfter = parseInt(xhr.getResponseHeader('Retry-After'), 10);
            const wait = !isNaN(retryAfter) && retryAfter > 0
              ? retryAfter * 1000
              : Math.min(1000 * Math.pow(2, nextAttempt), 4000);

            window.setTimeout(function () {
              removeCartLine(nextAttempt + 1);
            }, wait);
            return;
          }

          $lineRow.removeClass('disabled');
          $('.cart__remove-link').removeClass('disabled');

          if (xhr.status === 429 || xhr.status === 430) {
            window.setTimeout(function () {
              window.location.reload();
            }, 3000);
          }
        },
      });
    }

    removeCartLine(0);
  });

  // / below is a script that fires only on the cart page,
  // checks for line item bundles outputted by metafields
  // and injects them as cart attributes via cart.js
  // added by Ben @ eHouse on 1.30.19

  // if ($('.template-cart')[0]) {
  //   $.ajax({
  //     type: 'GET',
  //     url: '/cart?view=test.json',
  //     success(response) {
  //       json_response = JSON.parse(response);
  //       console.log('json_response', json_response);
  //       let i;
  //       for (i = 0; i < json_response.items.length; i++) {
  //         const bundle_name = json_response.items[i].metafield_name;
  //         const metafield = json_response.items[i].metafield_bundle;
  //         const variant_id = json_response.items[i].metafield_variantid;
  //         const qty = json_response.items[i].metafield_quantity;
  //         // console.log("Item " + i);
  //         // console.log(bundle_name + metafield + variant_id + qty);
  //         updateDiss(bundle_name, metafield, variant_id, qty);
  //       }

  //     },
  //     error(status) {
  //       console.warn('ERROR', status);
  //     },
  //   });

  //   function updateDiss(bundle_name, metafield, variant_id, qty) {

  //     console.log("updateDiss")
  //     if (bundle_name == null) {
  //       // do nothing
  //     } else {
  //       // CartJS.setAttribute(bundle_name, metafield);
  //     }
  //   }
  // }// end cart attribute bundle script

  $('[data-shorten]').each(function () {
    $(this).moreLines({
      linecount: (parseInt($(this).attr('data-shorten-line')) > 0) ? $(this).attr('data-shorten-line') : 10,
      baseclass: 'b-description',
      basejsclass: 'js-description',
      classspecific: '_readmore',
      buttontxtmore: 'Read More',
      buttontxtless: 'Less',
      animationspeed: 250,
    });
  });

});

// Listens for Cart Event and Updates Cart Counters
$(document).on('cart.requestComplete', (event, cart) => {
  document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
    detail: {
      product: cart
    }
  }));
});

$(document).on('ready', () => {
  // this script closes the mobile menu when the search form is submitted
  if (site.browserWidth < 1025) {
    document.getElementsByClassName('header__search-form')[0].addEventListener('submit', toggleMobileNav);

    function toggleMobileNav(event) {
      event.preventDefault();

      $nav.toggleClass('active');
      $('body').toggleClass('nav-active');
      $navToggle.toggleClass('is-active');
    }
  }// end if site browser width is less than 1025 & ends mobile menu search form

  $('.button--sticky-atc').on('click', (event) => {
    event.preventDefault();
    $('html, body').animate({
      scrollTop: $('#AddToCart').offset().top - $(window).outerHeight() + $('#AddToCart').outerHeight() + 20,
    }, 1000);
  });
  $('.slide---wrapper').slick({
    dots: true,
    slidesToShow: 1.2,
    slidesToScroll: 1,
    lazyLoad: 'ondemand',
    infinite: false,
  });

});

$(window).load(() => {
  // Adds aria label to klayvio footer for accessibility reasons
  $('.klaviyo-form input').attr('aria-label', 'Email Address');

  // Adds alt tag to magic zoom library for accessibility reasons
  $('.mz-lens > img').attr('alt', '');
  $('.mz-zoom-window > img').attr('alt', '');
  $('.mz-figure > img').attr('alt', '');

});

// $('.enhance-box').change(function(){
//   if($(this).is(":checked")) {
//       $(this).parent('.option_enhance').addClass('enhance-border');
//   } else {
//       $(this).parent('.option_enhance').removeClass('enhance-border');
//   }
// });


$('.pdp-en-checkbox').change(function () {
  if ($(this).is(':checked')) {
    $(this).parents('.option_enhance').addClass('enhance-border');

  } else {
    $(this).parents('.option_enhance').removeClass('enhance-border');

  }


});

// Custom Sections video modal
$(document).ready(() => {
  $('.custom-sections .video-icon').on('click', () => {
    $('body').css('overflow', 'hidden');
    $('.custom-sections .video-modal').show();
  });
  $('.custom-sections .video-modal').on('click', () => {
    $('body').css('overflow', 'visible');
    $('.custom-sections .video-modal').hide();
    $('.youtube-iframe').each(function (index) {
      $(this).attr('src', $(this).attr('src'));
      return false;
    });
  });
});


document.addEventListener('DOMContentLoaded', () => {
  LazyLoad.setupObservers();
  setTimeout(() => {
    $('.cart__remove-link').removeClass('disabled');
    $('.cart__qty').removeClass('disabled');
  }, 3000);
});


document.addEventListener("DOMContentLoaded", () => {
  // Pdp Mobile thumbs Gallery
  $('[data-js-product-thumbs-mobile-slider]').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 2,
    arrows: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 1025,
        settings: "unslick"
      }
    ]
  });

  $('[data-js-product-thumbs-mobile-slider]').css('visibility', 'visible');
  setTimeout(() => {
    $('.product-thumbs .mz-thumb').first().click()
  }, 100)
});


function calculateCartProgress(currentVal, targetVal) {
  const result = 100 * currentVal / targetVal;
  const progressPercentage = `${result}%`;

  // Update progress bar
  $('.progress-meter').css('width', progressPercentage);

  // Update the progess text. If threshold is met, show success message
  const newProgressNum = (targetVal - currentVal) / 100 * 100;
  const progressDollarNum = slate.Currency.formatMoney(newProgressNum, theme.moneyFormat).replace('.00', '');

  if (result < 100) {
    $('.js-money-remainder').text(` ${progressDollarNum} `);
    $('.shipping-success-message').addClass('hide');
    $('.shipping-message').removeClass('hide');
    $('.progress-meter').css({
      WebkitTransition: 'width 0.3s ease-in',
      MozTransition: 'width 0.3s ease-in',
      MsTransition: 'width 0.3s ease-in',
      OTransition: 'width 0.3s ease-in',
      transition: 'width 0.3s ease-in',
    });
  } else {
    $('.shipping-success-message').removeClass('hide');
    $('.shipping-message').addClass('hide');
  }
}

function updateShippingProgressBar() {
  var retrievedCountryCode = JSON.parse(localStorage.getItem('userCountryCode'));
  var admin_country_thresholds = window.ehouse.settings.country_threshold_value;
  var country_threshold_values = admin_country_thresholds.split(",");

  for (var i = 0; i < country_threshold_values.length; i++) {
    var [countryCode, threshold, barColor] = country_threshold_values[i].split("-");

    if (countryCode == retrievedCountryCode) {
      if (countryCode != 'US' && countryCode != 'CA') {
        countryCode = 'INT'
      }

      var countryCodeLow = countryCode.toLowerCase()
      window.setThreshold = threshold;

      $(".free-shipping-progress-container").removeClass("hide");
      $(`.${countryCodeLow}-message-container`).removeClass("hide");
      $(".free-shipping-progress-container .progress-meter").css("background", barColor);;
    }
  }
}
